<div class="modal fade" #modal>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="modal_header">{{ modal_header }}</h4>
        <button type="button" class="close pull-right float-right" aria-label="Close" (click)="closeModal('cancel')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="modal_body">
        {{ modal_body }}
      </div>
      <div class="modal-footer">
        <button type="button" (click)="closeModal('confirm')" [class]="'btn btn-' + confirm_class">{{ modal_confirm || 'Confirm' }}</button>
        <button type="button" class="btn btn-secondary" (click)="closeModal('cancel')" data-dismiss="modal">{{ modal_cancel || 'Cancel' }}</button>
      </div>
    </div>
  </div>
</div>
